export { default as component } from "../../../../src/routes/[prefix]/+layout.svelte";